<template>
  <div>
    <span v-if="noOrganization">{{ DASH }}s</span>
    <span v-else-if="showAllLabel">{{ capitalize($t('names.all')) }} </span>
    <OrganizationList
      v-else
      :organizations="organizations"
      :show-organization-name="!isPackageTile" />
  </div>
</template>

<script setup lang="ts">
  import { capitalize, computed, ComputedRef } from 'vue';

  import OrganizationList from '@/common/components/organization/OrganizationList.vue';
  import { IOrganizationLike } from '@/common/components/organization/OrganizationLogo.vue';
  import { OrganizationDSP } from '@/common/models';
  import ExternalExchange from '@/common/models/misc-api-models/ExternalExchange';
  import { DASH } from '@/globals';

  interface IProps {
    buyerExternalExchanges: ExternalExchange[];
    buyerExternalExchangeIDs: number[];
    buyerOrganizationDSPs: OrganizationDSP[];
    ids: number[];
    isPackageTile: boolean;
  }

  const props = defineProps<IProps>();

  const noOrganization = computed(
    () =>
      (props.buyerOrganizationDSPs == null || props.buyerOrganizationDSPs.length === 0) &&
      (props.buyerExternalExchanges == null || props.buyerExternalExchanges.length === 0),
  );

  const showAllLabel = computed(
    () => props.ids.length === 0 && props.buyerExternalExchangeIDs && props.buyerExternalExchangeIDs.length === 0,
  );

  const organizations: ComputedRef<IOrganizationLike[]> = computed(() =>
    props.buyerExternalExchangeIDs?.length > 0
      ? props.buyerExternalExchangeIDs.map((id) => {
          const externalExchange = props.buyerExternalExchanges.find((exchange) => exchange.externalExchangeID === id);
          return {
            name: externalExchange?.name,
            logoUrl: externalExchange?.logoURL,
          };
        })
      : props.ids.map((id) => {
          const organizationDSP = props.buyerOrganizationDSPs.find((buyer) => buyer.id === id);
          return {
            name: organizationDSP?.organization.name,
            logoUrl: organizationDSP?.dsp.logoUrl,
          };
        }),
  );
</script>
